export default {
    apiRootUrl: process.env.REACT_APP_API_ROOT_URL ?? '',
    apiRootKeyTenant: process.env.REACT_APP_API_ROOT_KEY_TENANT ?? '',
    apiRootKeyAdmin: process.env.REACT_APP_API_ROOT_KEY_ADMIN ?? '',
    apiRootKeyInvestor: process.env.REACT_APP_API_ROOT_KEY_INVESTOR ?? '',
    zerodhaKey: process.env.REACT_APP_ZERODHA_KEY ?? '',
    apiSecret: process.env.REACT_APP_API_SECRET ?? '',
    serviceType: process.env.REACT_APP_SERVICE_TYPE ?? '',
    tenentCode: process.env.REACT_APP_TENENT_CODE ?? '',
}